<template>
  <modal
    class="editTruck"
    name="mapGroupBranchModal"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
    @opened="opened"
    @closed="closed"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/deal.png" width="50px" />
          </span>
          <span v-if="this.$route.query.companyID">{{
            $t("text.gManagement.mapGroupToSite")
          }}</span>
          <span v-else>{{ $t("text.gManagement.mapGroupToBranch") }}</span>
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div v-if="branches">
              <div class="mt-3">
                <div class="mt-3 input__block">
                  <!-- <select
                    v-model="selectedBranch"
                    v-if="this.$route.query.companyID"
                  >
                    <option value="selectBranch" selected disabled>
                      {{ $t("text.gManagement.selectIndustryBranch") }}
                    </option>
                    <option
                      :value="branch.branchID"
                      v-for="(branch, index) in branches"
                      :key="index"
                    >
                      <span>
                        {{ branch.branchName }}
                      </span>
                    </option>
                  </select> -->
                  <multiselect
                    v-if="this.$route.query.companyID"
                    v-model="selectedBranch"
                    :options="branches"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Pick or search to select"
                    label="branchName"
                    track-by="branchID"
                  >
                  </multiselect>
                  <!-- <select v-model="selectedBranch" v-else>
                    <option value="selectBranch" selected disabled>
                      {{ $t("text.gManagement.selectCompanyBranch") }}
                    </option>
                    <option
                      :value="branch.id"
                      v-for="(branch, index) in branches"
                      :key="index"
                    >
                      <span>
                        {{ branch.name }}
                      </span>
                    </option>
                  </select> -->
                  <multiselect
                    v-else
                    v-model="selectedBranch"
                    :options="branches"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Pick or search to select"
                    label="name"
                    track-by="id"
                  >
                  </multiselect>
                </div>
              </div>

              <div class="text-center mt-5">
                <button
                  class="add_quick_fuel_btn"
                  @click="mapGroup($event)"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  <span>{{ $t("text.gManagement.mapGroup") }}</span>
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </div>
            </div>

            <div v-else>
              <p>{{ $t("text.gManagement.noBranchCreated") }}</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import Multiselect from "vue-multiselect";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  components: {
    Multiselect,
  },

  name: "mapGroupBranchModal",
  props: ["groupId", "company", "companyID"],

  data() {
    return {
      modalWidth: MODAL_WIDTH,
      // formIsValid: false,
      isButtonDisabled: false,
      branches: [],
      selectedBranch: [],
      // selectedBranch: "selectBranch",
    };
  },
  watch: {
    selectedBranch(sb) {
      if (sb !== "") {
        console.log(this.selectedBranch);
      }
    },
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeAssigBranchModals() {
      this.selectedBranch = [];
      this.$modal.hide("mapGroupBranchModal");
    },
    opened() {
      if (this.$route.query.companyID) {
        this.getSites();
      } else {
        this.getBranches();
      }
    },
    closed() {
      this.selectedBranch = [];
    },
    getSites() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/CompanyBranches/${this.companyID}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((data) => {
            data.value = data.id;
            data.text = data.name;
          });
          this.branches = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getBranches() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.company ? this.company.id : this.$route.query.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((data) => {
            data.value = data.id;
            data.text = data.name;
          });
          this.branches = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    mapGroup($event) {
      $event.preventDefault();
      if (this.selectedBranch.length <= 0) {
        this.$toast.open({
          message: this.$t("text.gManagement.errorMsg"),
          type: "error",
          duration: 3000,
        });
        // this.formIsValid = false;
        return;
      }

      // MULTISELECT MAPPED OUT TO GET JUST NAMES
      let newSB = [];
      this.selectedBranch.map((role) => {
        if (this.$route.query.companyID) {
          return newSB.push(role.branchID);
        } else {
          return newSB.push(role.id);
        }
      });

      // let companyID;
      // if (localStorage.getItem("companyDetails") !== null) {
      //   companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      // }
      // this.branchId = parseInt(this.branchId);
      // this.selectedGroup = parseInt(this.selectedGroup);
      let data = Object.assign(
        {},
        { groupId: this.groupId },
        { branchIds: newSB }
      );

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/GroupManagement/PostBranchListToGroup`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.$toast.open({
            message: this.$t("text.gManagement.successMsg"),
            type: "success",
            duration: 4000,
          });
          this.closeAssigBranchModals();
          this.$eventHub.$emit("getGPM");
          data = "";
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.closeAssigBranchModals();
        });
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
